import { MenuItem } from "@mui/material";
import { ReactElement } from "react";

import { FormikSelect } from "~frontend/components/forms/FormSelect";
import { prettyPhoneNumber } from "~frontend/util/phoneNumber";

import { OwnedPhoneNumber } from "../types";

export default function OwnedPhoneNumberPicker({
  readOnly,
  name,
  ownedPhoneNumbers,
}: {
  readOnly?: boolean;
  name: string;
  ownedPhoneNumbers: Pick<
    OwnedPhoneNumber,
    "id" | "phoneNumber" | "displayName"
  >[];
}): ReactElement {
  return (
    <FormikSelect
      name={name}
      fullWidth
      label="Phone Number"
      disabled={readOnly}
    >
      {ownedPhoneNumbers.map(phoneNumber => {
        const prettyNumber = prettyPhoneNumber(phoneNumber.phoneNumber);

        const formattedName = phoneNumber.displayName
          ? `${phoneNumber.displayName} - ${prettyNumber}`
          : prettyNumber;

        return (
          <MenuItem key={phoneNumber.id} value={phoneNumber.id}>
            {formattedName}
          </MenuItem>
        );
      })}
    </FormikSelect>
  );
}
